import styles from './ArrowToggle.module.css';

export const ArrowToggle = ({ isOpen }: {isOpen: boolean;}) => {
  return (
    <span className={`${styles.arrow} ${isOpen ? styles.open : ''}`}>
			<span
        className={`${styles.arrowIcon} ${isOpen ? styles.open : ''}`}>
      </span>
		</span>);

};